// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.8701 7.6377L12 1.01855L8.12891 7.6377L0.605469 9.26074L5.73535 14.9795L4.95996 22.6045L12 19.5146L19.04 22.6045L18.2637 14.9795L23.3945 9.26074L15.8701 7.6377Z"}}]};

const Star1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'star-1-filled',
    ref,
    icon: element,
  },
));

Star1FilledIcon.displayName = 'Star1FilledIcon';

export default Star1FilledIcon;
